'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var _extends = _interopDefault(require('@babel/runtime/helpers/extends'));
var IconWrapper = require('../IconWrapper.js');

var SvgUpChevron = function SvgUpChevron(props) {
  return /*#__PURE__*/React__default.createElement(IconWrapper.default, _extends({
    viewbox: 18,
    type: "upChevron"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    d: "M3.28 12.685c.385.404 1.017.415 1.412.022L9 8.443l4.307 4.27c.396.392 1.03.38 1.412-.023.382-.405.373-1.05-.024-1.444l-5-4.958c-.39-.384-1.003-.384-1.39 0l-5 4.953c-.204.2-.306.467-.306.734 0 .255.094.512.28.71z"
  }));
};

process.env.NODE_ENV !== "production" ? SvgUpChevron.propTypes = {
  size: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string
} : void 0;
SvgUpChevron.IsIcon = true;

exports.default = SvgUpChevron;
